import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translate: TranslateService,
    private renderer: Renderer2,
    ){
      translate.setDefaultLang('en');
    }

    dir:boolean=false;

  ngOnInit(): void {
  }

  changeLangEN() {
    document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    this.renderer.addClass(this.document.body,'ltr');
    this.translate.use('en');
    this.dir = false;

    // document.getElementsByTagName('html')[0].removeAttribute('dir');
    // this.renderer.removeClass(this.document.body,'ltr');
  }

  changeLangAR() {
    document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    this.renderer.addClass(this.document.body,'rtl');
    this.translate.use('ar');
    this.dir = true;
  }

}
